import { render, staticRenderFns } from "./PortalFilterBar.vue?vue&type=template&id=022ddcdb&scoped=true&"
import script from "./PortalFilterBar.vue?vue&type=script&lang=js&"
export * from "./PortalFilterBar.vue?vue&type=script&lang=js&"
import style0 from "./PortalFilterBar.vue?vue&type=style&index=0&id=022ddcdb&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "022ddcdb",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1664913644/src/struxture-clientportal/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('022ddcdb')) {
      api.createRecord('022ddcdb', component.options)
    } else {
      api.reload('022ddcdb', component.options)
    }
    module.hot.accept("./PortalFilterBar.vue?vue&type=template&id=022ddcdb&scoped=true&", function () {
      api.rerender('022ddcdb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/filters/PortalFilterBar.vue"
export default component.exports